<template>
  <span class="text-nowrap d-inline-flex align-items-center">
    <CBadge color="secondary" class="mr-1 unit-badge" :class="{'font-lg': $store.state.largeFont}"
            v-b-tooltip.hover title="부피 단위 (클릭: L → kL → D → gl 순환)" @click="$emit('toggle-vol')">{{ tankUnitSign(volUnit) }}</CBadge>
    <CBadge color="secondary" class="mr-1 unit-badge" :class="{'font-lg': $store.state.largeFont}"
            v-b-tooltip.hover title="길이 단위 (클릭: ㎜ ↔ in)" @click="$emit('toggle-len')">{{ tankUnitSign(lenUnit) }}</CBadge>
    <CBadge color="secondary" class="unit-badge" :class="{'font-lg': $store.state.largeFont}"
            v-b-tooltip.hover title="온도 단위 (클릭: °C ↔ °F)" @click="$emit('toggle-tmp')">{{ tankUnitSign(tmpUnit) }}</CBadge>
  </span>
</template>

<style scoped>
.unit-badge {
  cursor: pointer;
  user-select: none;
}
.unit-badge:hover {
  filter: brightness(1.3);
}
</style>

<script>
/**
 * 탱크 카드의 현재 표시 단위(부피·길이·온도) 배지.
 * 배지를 누르면 그 단위만 바뀐다 (toggle-vol / toggle-len / toggle-tmp 이벤트를 올리고 호출측이 처리).
 * 부피는 L → kL → 드럼(D) → gal 순환, 길이는 ㎜ ↔ in, 온도는 °C ↔ °F.
 * 상단 용량·유량·충족률 버튼 그룹 오른쪽(아웃라인 버튼 안)에 한 번만 보여준다.
 */
import {tankUnitSign} from '@/common/utils';

export default {
  name: 'TankUnitBadges',
  props: {
    volUnit: {type: String, default: 'l'},
    lenUnit: {type: String, default: 'mm'},
    tmpUnit: {type: String, default: 'c'},
  },
  methods: {
    tankUnitSign,
  },
}
</script>
